import { render, staticRenderFns } from "./StatusMetabox.vue?vue&type=template&id=33b137f2&"
import script from "./StatusMetabox.vue?vue&type=script&lang=js&"
export * from "./StatusMetabox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports